import React from 'react';
import styled from 'styled-components';
import FilterStationVenue from './FilterStationVenue';
import VenueTagStation from './VenueTagStation';

const VenueMetaStation: React.FC = () => (
  <VenueMetaStationContainer>
    <VenueTagStation />
    <FilterStationVenue />
  </VenueMetaStationContainer>
);

export default VenueMetaStation;

const VenueMetaStationContainer = styled.div`
  width: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5vw;
  padding-bottom: 4px;
`;
